/**
 * Remove background
 *
 * Declares its `assets/rmbg-data/` tree (the background-removal model data and its
 * ONNX-runtime WebAssembly, under `assets/rmbg-data/ort/`) as web-accessible to
 * `<all_urls>` with no `use_dynamic_url`. Two further resources are scoped to cutoutly.com.
 *
 * The model-weight files are content-addressed sha256 names, so we probe the stable
 * onnxruntime wasm filenames under the vendor `rmbg-data/ort/` path instead — those names
 * come from the ORT distribution and do not rotate per build. The URL carries the
 * extension ID, so a successful fetch is conclusive.
 *
 * Manifest verified against version 3.0.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lidlocdecbjopdnblcplkgcojdnngdif';

export const removeBackground: ExtensionDefinition = {
  id: ID,
  name: 'Remove background',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 40_000,
  notes:
    'assets/rmbg-data/ exposed to every origin with no dynamic URL. Model weights are ' +
    'sha256-named, so we probe the stable ORT wasm files under the vendor rmbg-data/ort path.',
  signals: [
    {
      id: 'war-ort-wasm-simd-threaded',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/rmbg-data/ort/ort-wasm-simd-threaded.wasm — a stable onnxruntime ' +
        'binary under the vendor rmbg-data path, reachable from any origin.',
      weight: 1,
      run: () => probeFetch(ID, 'assets/rmbg-data/ort/ort-wasm-simd-threaded.wasm'),
    },
    {
      id: 'war-ort-wasm-simd',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/rmbg-data/ort/ort-wasm-simd.wasm — a second stable ORT binary, ' +
        'corroborating without relying on the sha256-named model weights.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/rmbg-data/ort/ort-wasm-simd.wasm'),
    },
  ],
};
